<app-panel panelTitleIcon="../../../assets/icones/ic_performance.svg" panelTitleSmall="Meu" panelTitle="Desempenho" [loading]="loading" [noData]="!dadosGrafico || dadosGrafico.valores.length <= 0" noDataText="Sem fichas">
    <div class="row">
        <div class="col-xs-12">
            <ul class="resume">
                <li>
                    <span class="icon sos"></span>
                    <div>
                        <h3>{{dadosGrafico?.sosCredito}}</h3>
                        <small>SOS Crédito</small>
                    </div>
                </li>

                <li>
                    <span class="icon sos"></span>
                    <div>
                        <h3>{{dadosGrafico?.sosFormalizacao}}</h3>
                        <small>SOS Formalização</small>
                    </div>
                </li>

                <li>
                    <span class="icon contract"></span>
                    <div>
                        <h3>{{dadosGrafico?.pagamentoAgendado}}</h3>
                        <small>Pagamento Agendado</small>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <!-- Chart -->
    <div id="canvas-holder" #canvasHolder>
    </div>
</app-panel>